import { LOCATION_CHANGE } from 'connected-react-router';
import {
  /* UPDATE_BUSINESS_INFO,*/ CREATE_BUSINESS,
  FETCH_BUSINESS_DETAILS, LOAD_ALL_DATA_FOR_BUSINESS,
  CREATE_CPA_TOKENS_CAMPAIGN, CREATE_DONATION_CAMPAIGN,
} from '../../constants';
import BusinessActions from './actions';
import MediaActions from '../media/actions';
import CampaignActions from '../campaign/actions';
import TwoKeyStorage from '../../_core/2KeyStorage';
import { authHelpers } from '../../Auth/helpers';
// import { CAMPAIGN_STATUS } from '../../constants/campaign';
// import { setBusinessMode, businessRegex } from '../wallet/middleware';

const businessActions = {
  [`${CREATE_BUSINESS}_SUCCESS`]: true,
  // [`${UPDATE_BUSINESS_INFO}_SUCCESS`]: true,
  [`${CREATE_CPA_TOKENS_CAMPAIGN}_SUCCESS`]: true,
  [`${CREATE_DONATION_CAMPAIGN}_SUCCESS`]: true,
};

const refreshData = store => {
  const state = store.getState();
  const businessList = state.business.get('businessList');
  const id = state.business.getIn(['businessDetails', 'business', 'id']);
  // const plasmaAddress = state.business.getIn(['businessDetails', 'business', 'plasma_address']);
  const owner_business_ids = state.user.getIn(['userMetadata', 'owner_business_ids']);
  if (id) {
    store.dispatch(BusinessActions.FETCH_BUSINESS_LIST());
    // store.dispatch(BusinessActions.FETCH_BUSINESS_CAMPAIGNS(id, plasmaAddress));
    store.dispatch(BusinessActions.FETCH_BUSINESS_DETAILS(id));
    const isBusinessOwner = owner_business_ids.indexOf(id) !== -1;
    // if (isBusinessOwner) {
    //   store.dispatch(BusinessActions.FETCH_BUSINESS_AUDIENCES(id));
    // }
    if (businessList.get && businessList.get(id) && isBusinessOwner) {
      store.dispatch(BusinessActions.FETCH_BUSINESS_PAYMETHOD_LIST(id));
      // store.dispatch(PendingActions.FETCH_PENDINGS(id));
      // store.dispatch(ProductActions.FETCH_PRODUCT_LIST(id));
      store.dispatch(MediaActions.FETCH_MEDIA_LIST({ business_id: id }));
    }
  }
};

const loadBusiness = async(store, { handleOrId, resetCampaignData }) => {
  const state = store.getState();
  const currentHandle = state.business.getIn(['businessDetails', 'business', 'handle']);
  const currentId = state.business.getIn(['businessDetails', 'business', 'id']);
  if (currentHandle !== handleOrId && String(currentId) !== String(handleOrId) && handleOrId !== 'create') {
    if (!authHelpers.isAuthenticated()) {
      authHelpers.generateGuestToken();
    }
    // const userId = state.user.getIn(['userMetadata', 'id']);
    const owner_business_ids = state.user.getIn(['userMetadata', 'owner_business_ids'])
      || (TwoKeyStorage.getItem('userProfile')
        && JSON.parse(TwoKeyStorage.getItem('userProfile')).owner_business_ids) || [];
    try {
      const { business } = await store.dispatch(BusinessActions.FETCH_BUSINESS_DETAILS({
        handleOrId,
        resetCampaignData,
      }));
      const isBusinessOwner = owner_business_ids.indexOf(business.id) !== -1;
      // store.dispatch(BusinessActions.FETCH_BUSINESS_CAMPAIGNS(business.id, business.plasma_address));
      // store.dispatch(BusinessActions.FETCH_PAGE_CAMPAIGNS_BY_STATUS({
      //   business_id: business.id, status: [CAMPAIGN_STATUS.active].join(','),
      // }));

      if (isBusinessOwner) {
        store.dispatch(BusinessActions.FETCH_BUSINESS_PAYMETHOD_LIST(business.id));
        store.dispatch(MediaActions.FETCH_MEDIA_LIST({ business_id: business.id }));
      }
    } catch (e) {
      console.log('Error business loading', e);
    }
  }
};

export default store => next => action => {
  if (action.type === LOAD_ALL_DATA_FOR_BUSINESS) {
    next(action);
    loadBusiness(store, action.payload).catch(() => {});
    return;
  }
  next(action);
  if (action.type === LOCATION_CHANGE) {
    store.dispatch({ type: 'CLEAR_NOT_FOUND' });
    if (action.payload.location.pathname.startsWith('/page')) {
      const state = store.getState();
      const id = state.business.getIn(['businessDetails', 'business', 'id'], '');
      const handle = state.business.getIn(['businessDetails', 'business', 'handle']);
      const newHandle = action.payload.location.pathname.split('/')[2];

      if (id.toString() !== newHandle && handle !== newHandle) {
        console.log('CLEAR_BUSINESS', id, handle, newHandle);
        store.dispatch({ type: 'CLEAR_SELECTED_PAGE' });
        store.dispatch({ type: 'SET_BUSINESS_DETAIL_EXPAND', payload: false });
      }
    }
  }
  if (action.type === `${FETCH_BUSINESS_DETAILS}_REQUEST`) {
    const state = store.getState();
    const id = state.business.getIn(['businessDetails', 'business', 'id']);
    const handle = state.business.getIn(['businessDetails', 'business', 'handle']);
    if (id || handle) {
      if (!(action.payload === handle || action.payload === id)) {
        store.dispatch({ type: 'CLEAR_CAMPAIGNS' });
        if (action.payload?.resetCampaignData) {
          store.dispatch(CampaignActions.CLEAR_CAMPAIGN_DATA());
        }
        store.dispatch({ type: 'CLEAR_MEDIAS' });
        store.dispatch({ type: 'CLEAR_PENDINGS' });
        store.dispatch({ type: 'CLEAR_AUDIENCES' });
        const owner_business_ids = state.user.getIn(['userMetadata', 'owner_business_ids'])
          || (TwoKeyStorage.getItem('userProfile')
            && JSON.parse(TwoKeyStorage.getItem('userProfile')).owner_business_ids) || [];
        const isBusinessOwner = owner_business_ids.indexOf(id) !== -1;
        if (isBusinessOwner) {
          store.dispatch(BusinessActions.FETCH_BUSINESS_PAYMETHOD_LIST(id));
          store.dispatch(MediaActions.FETCH_MEDIA_LIST({ business_id: id }));
        }
      }
    }
  }
  if (action.type === `${CREATE_BUSINESS}_SUCCESS`) {
    store.dispatch({ type: 'CLEAR_MEDIAS' });
    // TODO ADD SMART CLEAN UP ON CREATING NEW BUSINESS
    /* store.dispatch(CampaignActions.CLEAR_CAMPAIGN_DATA()); */
  }
  if (businessActions[action.type]) {
    refreshData(store);
  }
};
